//import {required} from "vuelidate/lib/validators";  
import {required } from "@vuelidate/validators";
const oresmitatil = {
    data() {
      return { 
        oresmitatilData:{   
          Adi:null,
          Gun:null,
          Ozel:null,
          Yarimgun:null,
        },  
          FormDataType:{
            Adi:{FieldName:"Adi",Field:"input",FieldTitle:"Adı",FieldType:"text"},
            Gun:{FieldName:"Gun",Field:"date",FieldTitle:"Gün"},  
            Ozel:{FieldName:"Ozel",Field:"checkbox",FieldTitle:"Özel"} ,
            Yarimgun:{FieldName:"Yarimgun",Field:"checkbox",FieldTitle:"Yarım Gün"} 
          }  
      } 
    },
    validations:{ 
      FormData: {
          Adi: { required },  
          Gun: { required }, 
          Ozel: {  }, 
          Yarimgun: { },  
      } 
  },
}
export default oresmitatil